import createClient from '../../helpers/api-client';

import { clone } from '../../helpers';

const storeSuffix = 'Requests';

// Actions
export const FETCH_REQUESTS = `fetchRequestsByQueryAction${storeSuffix}`;

export const SET_QUERY_ACTION = `setQueryAction${storeSuffix}`;
export const SET_TAKE_ACTION = `setTakeAction${storeSuffix}`;
export const SET_PAGE_ACTION = `setPageAction${storeSuffix}`;
export const SET_CATEGORY_ACTION = `setRequestsCategoryAction${storeSuffix}`;
export const SET_REGION_ACTION = `setRequestsRegionAction${storeSuffix}`;
export const SET_RATING_ACTION = `setRequestsRatingAction${storeSuffix}`;
export const SET_CERTIFICATE_ACTION = `setRequestsCertificateAction${storeSuffix}`;

export const RESET_SEARCH_ACTION = `resetAction${storeSuffix}`;

// Mutations
export const BEGIN_FETCH_REQUESTS = `beginFetchRequestsMutation${storeSuffix}`;
export const RECEIVED_REQUESTS = `receivedRequestsMutation${storeSuffix}`;
export const REQUESTS_NOT_FOUND = `requestsNotFoundMutation${storeSuffix}`;

export const SET_QUERY = `setQueryMutation${storeSuffix}`;
export const SET_TAKE = `setTakeMutation${storeSuffix}`;
export const SET_PAGE = `setPageMutation${storeSuffix}`;
export const SET_CATEGORY = `setRequestsCategoryMutation${storeSuffix}`;
export const SET_REGION = `setRequestsRegionMutation${storeSuffix}`;

export const RESET_SEARCH = `resetSearchMutation${storeSuffix}`;

// Getters
export const GET_REQUESTS = `getRequestsGetter${storeSuffix}`;
export const IS_LOADING = `getIsLoadingGetter${storeSuffix}`;
export const GET_ERROR = `getErrorGetter${storeSuffix}`;

export const GET_SEARCH_PARAMS = `getSearchParamsGetter${storeSuffix}`;
export const GET_PAGE = `getPageGetters${storeSuffix}`;

export const modelState = () => ({
    requests: {
        isLoading: true,
        error: false,
        searchParams: {
            q: '',
            page: 1,
            take: 10,
            category: null,
            region: null,
        },
        data: [],
    },
});

export const actions = {
    [FETCH_REQUESTS]: ({ state, commit }) => {
        return new Promise(async (resolve, reject) => {
            // const apiClient = createClient(state);

            const isAuthenticated = state.authentication.authenticated;
            const apiClient = createClient(state, {
                headers: {
                    Authorization: isAuthenticated
                        ? `Bearer ${state.authentication.authenticationToken}`
                        : '',
                },
            });
            console.log(apiClient);
            commit(BEGIN_FETCH_REQUESTS);
            try {
                const payload = clone(state.requests.searchParams);
                payload.regionid = payload.region ? payload.region.Id : null;
                delete payload.region;

                payload.categoryid = payload.category
                    ? payload.category.Id
                    : null;
                delete payload.category;
                const res = await apiClient.get(`/api/requests`, {
                    params: payload,
                });
                console.dir({'FETCH_REQUEST':res})
                commit(RECEIVED_REQUESTS, res);

                resolve(res);
            } catch (error) {
                commit(REQUESTS_NOT_FOUND, {
                    error,
                });
                reject(error);
            }
        });
    },
    [SET_QUERY_ACTION]: ({ state, commit }, query) => {
        commit(SET_QUERY, query);
    },
    [SET_TAKE_ACTION]: ({ state, commit }, take) => {
        commit(SET_TAKE, take);
    },
    [SET_PAGE_ACTION]: ({ state, commit, dispatch }, page) => {
        commit(SET_PAGE, page);
    },
    [SET_CATEGORY_ACTION]: ({ state, commit }, category) => {
        commit(SET_CATEGORY, category);
    },
    [SET_REGION_ACTION]: ({ state, commit }, region) => {
        commit(SET_REGION, region);
    },
    [RESET_SEARCH_ACTION]: ({ state, commit }) => {
        commit(RESET_SEARCH);
    },
};

export const mutations = {
    [BEGIN_FETCH_REQUESTS]: state => {
        state.requests.isLoading = true;
        state.requests.error = false;
    },
    [RECEIVED_REQUESTS]: (state, payload) => {
        const { data } = payload;
        state.requests.isLoading = false;
        state.requests.error = false;
        state.requests.data = data;
    },
    [REQUESTS_NOT_FOUND]: (state, payload) => {
        state.requests.isLoading = false;
        state.requests.error = true;
    },
    [SET_QUERY]: (state, query) => {
        state.requests.searchParams.q = query;
        state.requests.searchParams.page = 1;
    },
    [SET_TAKE]: (state, take) => {
        state.requests.searchParams.take = take;
        state.requests.searchParams.page = 1;
    },
    [SET_PAGE]: (state, page) => {
        state.requests.searchParams.page = page;
    },
    [SET_CATEGORY]: (state, category) => {
        state.requests.searchParams.category = category;
        state.requests.searchParams.page = 1;
    },
    [SET_REGION]: (state, region) => {
        state.requests.searchParams.region = region;
        state.requests.searchParams.page = 1;
    },
    [RESET_SEARCH]: (state, payload) => {
        state.requests.isLoading = false;
        state.requests.error = false;
        state.requests.searchParams = {
            q: '',
            page: 1,
            take: 10,
            category: null,
            region: null,
        };
        state.requests.data = [];
    },
};

export const getters = {
    [GET_REQUESTS]: state => {
        return state.requests.data;
    },
    [IS_LOADING]: state => {
        return state.requests.isLoading;
    },
    [GET_ERROR]: state => {
        return state.requests.error;
    },
    [GET_SEARCH_PARAMS]: state => {
        return state.requests.searchParams;
    },
    [GET_PAGE]: state => {
        return state.requests.searchParams.page;
    },
};



// WEBPACK FOOTER //
// ./src/store/store-models/requests-model.js